import type { Metadata } from "next";
import { TermsView } from "@/components/legal/terms-view";

export const metadata: Metadata = {
  title: "Terms of Service",
  description:
    "Terms of service governing the use of the Quto AI website and services.",
  alternates: { canonical: "/terms" },
};

export default function TermsPage() {
  return <TermsView />;
}
